import App from '../app';
import Pricing from './pricing';

const Modules = {
    Pricing
}

App.init(Modules);
